import * as React from 'react';
import WebGLDirector from '../../webGL/WebGLDirector';
import Color from '../../webGL/Color';
import WebGLTextOrientation from '../../webGL/WebGLTextOrientation';
import WebGLArrow from '../../webGL/shapes/composites/WebGLArrow';
import WebGLText from '../../webGL/WebGLText';

abstract class GLComponent extends React.Component<{width: number, height: number}, void> {

	protected heightFactor: number;

	protected canvas: HTMLCanvasElement;
	protected textOverlay: HTMLDivElement;

	render () {
		const width = this.props.width;
		const height = this.props.height;

		const pixelWidth = width + 'px';
		const pixelHeight = height + 'px';
		const renderWidth = width * 2;
		const renderHeight = height * 2;

		const topMargin = 0 - (height - height * this.heightFactor) / 2 + 'px';
		const bottomMargin = 0 - (height - height * this.heightFactor) / 2 + 20 + 'px';

		return (
			<div style={{position: 'relative', width: pixelWidth, margin: 'auto'}}>
				<canvas ref={element => this.canvas = element} width={renderWidth} height={renderHeight} style={{width: pixelWidth, height: pixelHeight, marginTop: topMargin, marginBottom: bottomMargin}} />
				<div ref={element => this.textOverlay = element} style={{position: 'absolute', top: 0, width: pixelWidth, height: pixelHeight, marginTop: topMargin, marginBottom: bottomMargin}} />
			</div>
		);
	}

	protected drawVector (director: WebGLDirector, xStart: number, yStart: number, xComponent: number, yComponent: number, color: Color, displayText = false) {
		const orientation = xComponent >= 0 ? (yComponent > 0 ? WebGLTextOrientation.TOP_RIGHT : WebGLTextOrientation.BOTTOM_RIGHT) : (yComponent > 0 ? WebGLTextOrientation.TOP_LEFT : WebGLTextOrientation.BOTTOM_LEFT);

		director.addShape(WebGLArrow.fromNumbers(xStart / 10, yStart / 10, (xStart + xComponent) / 10, (yStart + yComponent) / 10).setColor(color));

		if (displayText) {
			director.addText(new WebGLText(`<${xComponent}, ${yComponent}>`, (xStart + xComponent) / 10, (yStart + yComponent) / 10, orientation, 0));
		}
	}
}

export default GLComponent;


// WEBPACK FOOTER //
// ./code/project/pages/components/lesson/WebGL/GLComponent.tsx